import React from "react"

const VersePage = () => {
  return <div className="page">Verse Page</div>
}

export default VersePage
